import DownloadIcon from "@mui/icons-material/Download";
import IconButton from "@mui/material/IconButton";
import { FormatDate } from "../../utils/common/DateUtils";

export const ViewInitiatorGrnData = {
  columns: [
    { field: "trsts", headerName: "Status", width: 100 },

    {
      field: "grncode",
      headerName: "GRN ID",
      flex: 1,
    },

    {
      field: "endate",
      headerName: "GRN Date",
      flex: 1,
        textAlign: "CENTER",
    },
    {
      field: "suprefcode",
      headerName: "Supplier Code",
      flex: 1,
    },
    {
      field: "suppliername",
      headerName: "Supplier Name",
      flex: 1,
      textTransform: "capitalize",
    },

     {
      field: "lastupdateuser",
      headerName: "last Updated User",
      flex: 1,
    },
  ],

  name: "GRN List",
};

export const ViewInitiatorHistoryGrnData = {
 columns: [
    // { field: "trsts", headerName: "Status", width: 100 },

    {
      field: "grncode",
      headerName: "GRN ID",
      flex: 1,
    },
{
      field: "endate",
      headerName: "GRN Date",
      flex: 1,
        textAlign: "CENTER",
    },
     {
      field: "ponumber",
      headerName: "PO Number",
      flex: 1,
    },
    
    {
      field: "podate",
      headerName: "PO Date",
      flex: 1,
   textAlign: "CENTER",
    },
    //  {
    //   field: "grnreturncode",
    //   headerName: "Return ID",
    //   flex: 1,
    // },

    
       
  
   
   {
      field: "Supplier",
      headerName: "Supplier Details",
      flex: 1,
      textTransform: "capitalize",
    },
    {
      field: "invoiceno",
      headerName: "Invoice Number",
      flex: 1,
    },
    
  ],

  name: "GRN History",
};

export const ViewHistoryGrnData = {

  columns: [

     { field: "trsts", headerName: "Status", width: 100 },

    { field: "grncode", headerName: "GRN ID", flex: 1 },

    { field: "endate", headerName: "GRN Date",  textAlign: "CENTER", flex: 1 },

    { field: "enuser", headerName: "Username", flex: 1 },

    { field: "endate", headerName: "Date",  textAlign: "CENTER", flex: 1 },

    { field: "suprefcode", headerName: "Supplier Code", flex: 1 },

    {

      field: "suppliername",

      headerName: "Supplier Name",

      flex: 1,

      textTransform: "capitalize",

    },

  ],




  name: "GRN List History", 

};


export const ViewApproverGrnData = {
  columns: [
    { field: "trsts", headerName: "Status", width: 100 },

    {
      field: "grncode",
      headerName: "GRN ID",
      flex: 1,
    },

    

    {
      field: "endate",
      headerName: "GRN Date",
      textAlign: "CENTER",
      flex: 1,
    },
    {
      field: "suprefcode",
      headerName: "Supplier Code",
      flex: 1,
    },
    {
      field: "suppliername",
      headerName: "Supplier Name",
      flex: 1,
      textTransform: "capitalize",
    },
   
     {
      field: "lastupdateuser",
      headerName: "last Updated User",
      flex: 1,
    },
  ],

  name: "GRN Approvals List ",
};

export const ViewApproverReturnGrnData = {
  columns: [
    { field: "trsts", headerName: "Status", width: 100 },

    {
      field: "grncode",
      headerName: "GRN ID",
      flex: 1,
    },

     {
      field: "grnreturncode",
      headerName: "Return ID",
      flex: 1,
    },

    {
      field: "invoicedate",
      headerName: "GRN Date",
      textAlign: "CENTER",
      flex: 1,
    },
  
    {
      field: "Supplier",
      headerName: "Supplier Details",
      flex: 1,
      textTransform: "capitalize",
    },
    // {
    //   field: "enuser",
    //   headerName: "Username",
    //   flex: 1,
    // },
     {
      field: "lastupdateuser",
      headerName: "last Updated User",
      flex: 1,
    },
  ],

  name: "Purchases Return Approvals List",
};

export const ViewReturnGrnData = {
  columns: [
   { field: "trsts", headerName: "Status", width: 100 },

    {
      field: "grncode",
      headerName: "GRN ID",
      flex: 1,
    },
 {
      field: "grnreturncode",
      headerName: "Return ID",
      flex: 1,
    },
    {
      field: "endate",
      headerName: "GRN Date",
      textAlign: "CENTER",
      flex: 1,
    },
        
  
    {
      field: "suprefcode",
      headerName: "Supplier Code",
      flex: 1,
    },
    {
      field: "suppliername",
      headerName: "Supplier Name",
      flex: 1,
      textTransform: "capitalize",
    },
    {
      field: "enuser",
      headerName: "Username",
      flex: 1,
    },
     {
      field: "lastupdateuser",
      headerName: "last Updated User",
      flex: 1,
    },
  ],

  name: "GRN List",
};

export const ViewAppGrnData = {
  columns: [
    // { field: "trsts", headerName: "Status", width: 100 },

    {
      field: "grncode",
      headerName: "GRN ID",
      flex: 1,
    },

    {
      field: "endate",
      headerName: "GRN Date",
        textAlign: "CENTER",
      flex: 1,
    },
    
    {
      field: "ponumber",
      headerName: "PO Number",
      flex: 1,
    },
    
    {
      field: "podate",
      headerName: "PO Date",
      flex: 1,
      textAlign: "CENTER",
    },
    // {
    //   field: "suprefcode",
    //   headerName: "Supplier Code",
    //   flex: 1,
    // },
    {
      field: "Supplier",
      headerName: "Supplier Details",
      flex: 1,
      textTransform: "capitalize",
    },
 {
      field: "restname",
      headerName: "Delivery Location",
      flex: 1,
    },
    
     
  ],

  name: "GRN List",
};

export const ViewReturnGoodGrnData = {
  columns: [
    //  { field: "trsts", headerName: "Status", width: 100 },
        {
      field: "grncode",
      headerName: "GRN ID",
      flex: 1,
    },
 {
      field: "grnreturncode",
      headerName: " Return ID",
      flex: 1,
    },
    {
      field: "returneddate",
      headerName: "Return Date",
        textAlign: "CENTER",
      flex: 1,
    },

 
      {
      field: "invoiceno",
      headerName: "Invoice Number",
      flex: 1,
    },
     {
      field: "ponumber",
      headerName: "PO Number",
      flex: 1,
    },
    //  {
    //   field: "batchno",
    //   headerName: "Batch Number",
    //   flex: 1,
    // },
     
  
    {
      field: "Supplier",
      headerName: "Supplier Details",
      flex: 1,
      textTransform: "capitalize",
    },
    
{
      field: "debitnoteno",
      headerName: "Debit Note Number",
      flex: 1,
    },
     {
      field: "totaftertaxamount",
      headerName: "Return Value",
      flex: 1,
      align: "right",
      headeralign: "right",
    },
    //  {
    //   field: "batchno",
    //   headerName: "Batch Number",
    //   flex: 1,
    // },
    
  
    
       
  
   
  
    
  ],

  name: "Purchases Return History",
};

export const ApproveReturnGrnData = {
  columns: [
    { field: "STATUS", headerName: "Status", width: 100 },

    { field: "GRNID", headerName: "GRN ID", flex: 1 },

    { field: "GRNDATE", headerName: "GRN Date", textAlign: "CENTER", flex: 1 },
    {
      field: "USERNAME",
      headerName: "User Name",
      flex: 1,
      // textAlign: "CENTER",
    },
    {
      field: "DATE",
      headerName: "Date",
      flex: 1,
      // textAlign: "CENTER",
    },
    { field: "SUPPLIERCODE", headerName: "Supplier Code", flex: 1 },
    {
      field: "SUPPLIERNAME",
      headerName: "Supplier Name",
      flex: 1,
      // textAlign: "right",
      textTransform: "capitalize",
    },

    // Add more column definitions as needed
  ],
  rows: [
    {
      field: 1,
      STATUS: "Returned",
      GRNID: "GRN12345",
      GRNDATE: "2025/03/05",
      USERNAME: "John Doe",
      DATE: "2025/03/05",
      SUPPLIERCODE: "SUP007",
      SUPPLIERNAME: "Roberto Carlos",
    },
    {
      field: 2,
      STATUS: "Returned",
      GRNID: "GRN12345",
      GRNDATE: "2025/03/05",
      USERNAME: "John Doe",
      DATE: "2025/03/05",
      SUPPLIERCODE: "SUP007",
      SUPPLIERNAME: "Roberto Carlos",
    },

    // Add more rows as needed
  ],

  name: "Approve Return GRN List",
};

// Supplier Module

export const supplierData = {
  columns: [
    // { field: "suptypecode", headerName: "Supplier Type", width: 100 },

    { field: "suppliername", headerName: "Supplier Name", flex: 1 },
    { field: "suptype", headerName: "Supplier Type", flex: 1 },
    { field: "email", headerName: "Email", flex: 1 },

    // Add more column definitions as needed
  ],
  rows: [
    {
      field: 1,
      STATUS: "Returned",
      SUPPLIERID: "#FFFFE0",
      SUPPLIERNAME: "Roberto Carlos",
      SUPPLIERTYPE: "john@gmail.com",
    },

    // Add more rows as needed
  ],

  name: "Supplier Accounts",
};

export const mappedproductData = {
  columns: [
    { field: "productname", headerName: "product name", width: 120, flex: 1 },

    { field: "brandname", headerName: "Brand name", width: 120, flex: 1 },
    {
      field: "minorderlevel",
      headerName: "Minimum Order Level",
      width: 200,
      flex: 1,
    },

    { field: "productdescrip", headerName: "description", width: 200, flex: 1 },
  ],

  name: "Mapped Products",
};

export const mappedchargeData = {
  columns: [
    { field: "supchargetype", headerName: "Charge Type", width: 120, flex: 1 },
  ],

  name: "Mapped Charges",
};

export const itemData = {
  columns: [
    { field: "productname", headerName: "product name", width: 120, flex: 1 },
    { field: "packagename", headerName: "package name", width: 120, flex: 1 },

    { field: "catname", headerName: "Category name", width: 200, flex: 1 },
    {
      field: "subcatname",
      headerName: " Subcategory name",
      width: 200,
      flex: 1,
    },
    { field: "brandname", headerName: "Brand name", width: 120, flex: 1 },
    {
      field: "minorderlevel",
      headerName: "Minimum Order Level",
      width: 200,
      flex: 1,
    },
    {
      field: "immeasuringunit",
      headerName: "measuring unit",
      width: 120,
      flex: 1,
    },
    { field: "descrip", headerName: "description", width: 200, flex: 1 },

    // Add more column definitions as needed
  ],

  name: "Supplier Accounts",
};

export const SupbankData = {
  columns: [
    { field: "bankcode", headerName: "Bank Code", flex: 1 },
    { field: "bankname", headerName: "Bank Name", flex: 1 },
    { field: "branchname", headerName: "Branch Name", flex: 1 },
    { field: "accountno", headerName: "account Number", flex: 1 },
    {
      field: "isdefault",
      headerName: "Primary Bank",
      flex: 1,
      renderCell: (params) => (params.value === "Y" ? "Yes" : "No"),
    },

    // Add more column definitions as needed
  ],

  name: "Create and Manage Supplier Accounts",
};

export const supplierBranchData = {
  columns: [
    { field: "branchname", headerName: "Branch Name", flex: 1 },

    { field: "contactno", headerName: "Contact Number", flex: 1 },

    { field: "country", headerName: "Country", flex: 1 },
    // { field: "EMAIL", headerName: "Email", flex: 1 },
    // { field: "ADDRESS", headerName: "Address", flex: 1 },

    // Add more column definitions as needed
  ],

  name: " Supplier Branch",
};

export const ApproveSupplierData = {
  columns: [
    { field: "STATUS", headerName: "Status", width: 100 },

    { field: "SUPPLIERCODE", headerName: "Supplier Code", flex: 1 },

    { field: "SUPPLIERNAME", headerName: "Supplier Name", flex: 1 },

    { field: "USERNAME", headerName: "User Name", flex: 1 },
    { field: "DATE", headerName: "Date", flex: 1 },
    { field: "SUPPLIERTYPE", headerName: "Supplier Type", flex: 1 },

    // Add more column definitions as needed
  ],
  rows: [
    {
      field: 1,
      STATUS: "Submitted",
      SUPPLIERCODE: "BOC",
      SUPPLIERNAME: "12345",
      USERNAME: "BOC-Colombo",
      DATE: "",
      SUPPLIERTYPE: "",
    },

    // Add more rows as needed
  ],

  name: "Supplier List",
};

export const SupplierAttachmentData = {
  columns: [
    { field: "doctype", headerName: "Document Type", flex: 1 },

    { field: "expdate", headerName: "Expiry Date",  textAlign: "CENTER", flex: 1 },

    { field: "description", headerName: "Description", flex: 1 },
    {
      field: "docpathjson",
      headerName: "Attachment",
      flex: 1,
      renderCell: (params) => {
        const fileUrl = params.value;
        if (!fileUrl) return null;
        return (
          <IconButton
            component="a"
            href={fileUrl}
            target="_blank"
            rel="noopener noreferrer"
            download
            aria-label="Download"
          >
            <DownloadIcon />
          </IconButton>
        );
      },
    },

    // Add more column definitions as needed
  ],

  name: "Supplier document List",
};

export const ViewMyApproverInitiator = {
  columns: [
    { field: "trsts", headerName: "Status", width: 100 },

  
   {
      field: "grncode",
      headerName: "GRN ID",
      flex: 1,
    },
     {
      field: "grnreturncode",
      headerName: "Return ID",
      flex: 1,
    },

   
     {
      field: "trcatcode",
      headerName: "Type",
      flex: 1,
    },
     {
      field: "endate",
      headerName: "Received Date",
      flex: 1,
    },
    {
      field: "Supplier",
      headerName: "Supplier Details",
      flex: 1,
      textTransform: "capitalize",
    },
  ],

  name: "Pending Approvals",
};

export const ViewMyActionInitiator = {
  columns: [
    { field: "trsts", headerName: "Status", width: 100 },

  
   {
      field: "grncode",
      headerName: "GRN ID",
      flex: 1,
    },
     {
      field: "grnreturncode",
      headerName: "Return ID",
      flex: 1,
    },

   
     {
      field: "trcatcode",
      headerName: "Type",
      flex: 1,
    },
     {
      field: "endate",
      headerName: "Received Date",
      flex: 1,
    },
    {
      field: "Supplier",
      headerName: "Supplier Details",
      flex: 1,
      textTransform: "capitalize",
    },
 
    
  ],

  name: "My Request",
};
